import React from 'react'
import ReactDOM from 'react-dom'
import JQueryRegistry from '@lib/JQueryRegistry'
import {initializeJQueryComponent} from '@lib/JQueryRegistry'

/**
 * Renders specified React component inside given container.
 *
 * @param {React.Component} component
 * @param {HTMLElement} container
 * @param {Object} params
 *
 * @return {React.Component}
 */
window.renderReactComponent = function (component, container, params) {
    let element = React.createElement(component, params)
    let instance = ReactDOM.render(element, container)

    container['__reactInstance'] = instance
    container['__reactElement'] = element

    // Initialize jQuery components containted inside this React component after it's been rendered.
    scheduleAtDocumentReady(() => {
        scheduleAtNextTick(() => {
            scheduleAtNextTick(() => {
                let components = JQueryRegistry.getEntries()
                for (let [selector, klass] of Object.entries(components)) {
                    $(selector).toJQueryObjectsArray().forEach(item => {
                        initializeJQueryComponent(klass, item)
                    })
                }
            })
        })
    })

    return instance
}

/**
 * Clones given element and renders it with new properties.
 *
 * @param {HTMLElement} domElement
 * @param {Object} nextProps
 *
 * @return {React.Component}
 */
window.updateReactProps = function (domElement, nextProps) {
    let element = React.cloneElement(domElement['__reactElement'], nextProps)
    let instance = ReactDOM.render(element, domElement)

    domElement['__reactInstance'] = instance
    domElement['__reactElement'] = element

    return instance
}

/**
 * Looks for an instance of {@link React.Component} in given element,
 * and returns it.
 *
 * Note: This will work only for components rendered using `renderReactComponent` function!
 *
 * @param {HTMLElement} element
 * @return {React.Component|null}
 */
window.findReactInstance = function (element) {
    if (element === undefined) {
        return null
    }

    if ('__reactInstance' in element) {
        return element['__reactInstance']
    }

    return null
}

window.isDocumentReady = false
window.React = React
window.ReactDOM = ReactDOM
window.scheduleAtNextTick = function (cb) {
    return setTimeout(cb)
};

window.scheduleAtDocumentReady = function (cb) {
    if (window.isDocumentReady) {
        cb()
    } else {
        $(document).ready(cb)
    }
};

$(document).ready(() => {
    window.isDocumentReady = true
})

export {
    renderReactComponent, updateReactProps, findReactInstance
}